import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'

import { HeaderShim } from "../fuselage/global/header/header"
import { FooterShim } from "../fuselage/global/footer/footer"
import { PageHeader } from '../fuselage/blocks/page-header/page-header'
import { SpeakerGrid } from '../fuselage/layout/speaker-grid/speaker-grid'
import { SpeakerCard } from "../fuselage/components/speaker-card/speaker-card"

import CSS from '../css/app/speakers.module.css'

function Speakers({ seomatic, craftCmsProfiles }) {

	// seo

	let metaTitle = JSON.parse(seomatic.metaTitleContainer)
    let metaTags = JSON.parse(seomatic.metaTagContainer) 

	// speakers

	// console.log('cms profile data:', craftCmsProfiles)

	return (
		<div style={{ width: `100%`, overflow: `hidden` }}>

			<Head>
                <title>{metaTitle.title.title}</title>

                <meta name="description" content={metaTags.description.content} />
                <meta name="referrer" content={metaTags.referrer.content} />
                {/* <meta name="robots" content={metaTags.robots.content} /> */}
                <meta content={metaTags['og:locale'].content} property="og:locale" />
                <meta content={metaTags['og:site_name'].content} property="og:site_name" />
                <meta content={metaTags['og:type'].content} property="og:type" />
                <meta content={metaTags['og:url'].content} property="og:url" />
                <meta content={metaTags['og:title'].content} property="og:title" />
                <meta content={metaTags['og:description'].content} property="og:description" />
                <meta content={metaTags['og:image'].content} property="og:image"></meta>  
            </Head>

			<HeaderShim />

			<PageHeader>
				<p className='fs-1 fw-600 lh-1'>Advisory Board</p>
				<p className="mt-sm">Made up of representatives from sponsoring companies and hand selected investors representing the most senior decision-makers and thought-leaders in the African hotel investment industry. The FHS Africa Advisory Board convenes annually to discuss the trends of the future of hospitality into the FHS Africa programme.</p>
			</PageHeader>

			<section className="block">
				<div className="container">
					
					<SpeakerGrid decal="gap-sm mt-md">
						{craftCmsProfiles.map( speaker => (
							<SpeakerCard
								key={speaker.id}
								url={`/speakers/profile/${speaker.slug}`}
								photoUrl={speaker.avatar[0] ? speaker.avatar[0].url : undefined}
								fullName={`${speaker.title}`}
								jobTitle={speaker.positions[0] && speaker.positions[0].jobTitle}
								company={speaker.positions[0] && speaker.positions[0].organisation}
							/>
						))}
					</SpeakerGrid>

				</div>
			</section>

		</div>
	)
}

export async function getStaticProps() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query SEO {
				entry(site: "${process.env.SITE_HANDLE}", id: "15801") {
					title
					seomatic (asArray: true) {
						metaTitleContainer
						metaTagContainer
					}
				}
			}
        `
    })


	const craftCmsProfiles = await craftApolloClient().query({
        query: gql`
            query Profiles {
                entries(site: "${process.env.SITE_HANDLE}", section: "profileGroups", id: "16501") {
					... on profileGroups_default_Entry {
						id
						title
						profiles {
							... on profiles_profile_Entry {
								id
								slug
								title
								avatar {
									... on avatars_Asset {
										id
										url
										width
										height
									}
								}
								positions {
									... on positions_BlockType {
										id
										jobTitle
										organisation
									}
								}
								profile
							}
						}
					}
				}
            }
          
        `
	})

	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			craftCmsProfiles: craftCmsProfiles.data.entries[0].profiles
		}
	}
}

export default Speakers


